import { DefaultService } from '@/services/DefaultService';


export default class SaldoProdutoService extends DefaultService {
    constructor(http, router, env) {
		super(http, router, env);
	}

    loadEstoque (page, limit, situacao, idProduto, search) {
        return this._http.get(`${this._env}/sales/saldoproduto.json?page=${page}&limit=${limit}&situacao=${situacao}&idproduto=${idProduto}&search=${search}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    
    loadEstoqueRemessa (page, limit, situacao, idProduto, search) {
        return this._http.get(`${this._env}/sales/saldoremessa.json?page=${page}&limit=${limit}&situacao=${situacao}&idproduto=${idProduto}&search=${search}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    
    loadEstoqueGrade (page, limit, situacao, idProduto, search, idempresa = 0) {
        return this._http.get(`${this._env}/sales/saldograde.json?page=${page}&limit=${limit}&situacao=${situacao}&idproduto=${idProduto}&idempresa=${idempresa}&search=${search}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    
    loadGrade(idProduto) {
        return this._http.get(`${this._env}/sales/saldograde/grade.json?idproduto=${idProduto}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    updateSituacao(contato) {
        return this._http.post(`${this._env}/sales/saldoproduto/updatesituacao`, contato, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacaoRemessa(contato) {
        return this._http.post(`${this._env}/sales/saldoremessa/updatesituacao`, contato, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacaoGrade(contato) {
        return this._http.post(`${this._env}/sales/saldograde/updatesituacao`, contato, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    find(id) {
        return this._http.get(`${this._env}/sales/saldoproduto/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findRemessa(id) {
        return this._http.get(`${this._env}/sales/saldoremessa/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    save(saldoproduto) {
        return this._http.post(`${this._env}/sales/saldoproduto`, saldoproduto, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveRemessa(saldoremessa) {
        return this._http.post(`${this._env}/sales/saldoremessa`, saldoremessa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveGrade(saldograde) {
        return this._http.post(`${this._env}/sales/saldograde/grade`, saldograde, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

}